module.exports = __webpack_public_path__ + "img/canasta.4c31bcdb.png";